import React from 'react';

import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import { ProductCarousel } from 'src/components/carousel-v2/types/product-carousel';

export function StaffPicksCarousel(props) {
  const { loading, products } = useDispensaryProducts({
    filters: {
      sortBy: `popularSortIdx`,
      staffPicks: true,
    },
    perPage: 25,
  });
  const title = `Staff Picks`;

  if (!products?.length && !loading) {
    return null;
  }

  return (
    <ProductCarousel
      products={products}
      isLoading={loading}
      hideTitle={props?.showTitle === false}
      hideLink={props?.showLink === false}
      title={title}
    />
  );
}
